
/**
 * Created by mathieudeumie on 30/04/2014.
 */

angular.module('FlexyBeautyApp.services').
    factory('Dashboard_Resource',["$resource","$location",
        function ($resource,$location)
        {
            var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
            return $resource(baseUrl+'rest/dashboard/:id',{}, {
                query: { method: 'GET', isArray: true },
                get: { method: 'GET' },
                export : { method: 'POST', url:baseUrl+'rest/dashboard/:id/export'}
            });
        }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('Dashboard',["Dashboard_Resource","DashboardData","DashboardScheduler",
        function (Dashboard_Resource,DashboardData,DashboardScheduler)
        {
            var Dashboard = function (resource)
            {
                this.id = "";
                this.title = null;
                this.taxMode = null;
                this.isFlexy = false;
                this.isDeleted = false;

                this.jsonDetail = "";
                this.dashboardSchedulers = [];

                this.version = null;
                if(resource !== undefined && resource !== null)
                    this.setValues(resource);

                DashboardData.add(this);
            };

            Dashboard.prototype.setId = function(id)
            {
                if (!this.id)
                    this.id = id;
            };

            Dashboard.prototype.getId = function()
            {
                return this.id;
            };

            Dashboard.prototype.setValues = function(resource)
            {
                this.id = resource.id;
                this.title = resource.title;
                this.taxMode = resource.taxMode;
                this.isFlexy = resource.flexy;
                this.isDeleted = resource.isDeleted;

                this.jsonDetail = resource.jsonDetail;
                for(var i = 0; i < resource.dashboardSchedulers.length; i++) {
                    this.dashboardSchedulers.push(new DashboardScheduler(resource.dashboardSchedulers[i], this.id));
                }
                if(resource.version)
                    this.version = resource.version;
            };

            Dashboard.prototype.getObjectResource = function()
            {
                var newDashboard = new Dashboard_Resource();

                newDashboard.id = this.id;
                newDashboard.title = this.title;
                newDashboard.taxMode = this.taxMode;

                newDashboard.isDeleted = this.isDeleted;
                newDashboard.jsonDetail = this.jsonDetail;
                newDashboard.dashboardSchedulers = this.dashboardSchedulers;

                return newDashboard;
            };

            Dashboard.prototype.removeDashboardScheduler = function(dashboardScheduler)
            {
                var index = this.dashboardSchedulers.indexOf(dashboardScheduler);
                if (index!=-1)//Found
                {
                    this.dashboardSchedulers.splice(index,1);
                }
            };

            Dashboard.prototype.addDashboardScheduler = function(dashboardScheduler)
            {
                if (dashboardScheduler)
                {
                    var index = this.dashboardSchedulers.indexOf(dashboardScheduler);
                    if (index==-1)//Not already there
                    {
                        this.dashboardSchedulers.push(dashboardScheduler);
                        dashboardScheduler.dashboardId = this.id;
                    }
                }
            }

            return Dashboard;
        }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('DashboardSrv',["$log","ServerSrv","Dashboard_Resource","DashboardData","UserActionData","Dashboard",
        function ($log,ServerSrv,Dashboard_Resource,DashboardData,UserActionData,Dashboard)
        {
            var dashboardSrv = {};

            dashboardSrv.query = function(successFunction,errorFunction)
            {
                Dashboard_Resource.query(
                    {},
                    function (data) {

                        DashboardData.clear();
                        for(var i=0;i<data.length;i++)
                        {
                            new Dashboard(data[i]);
                        }

                        if (successFunction!== undefined)
                            successFunction();
                    },
                    function (data) {
                        if (errorFunction !== undefined)
                            errorFunction(data);
                    }
                );
            };
            dashboardSrv.save = function(dashboard,successFunction,errorFunction)
            {
                ServerSrv.startSavingProcess(dashboardSrv.saveSync, dashboard, successFunction, errorFunction);
            };
            dashboardSrv.saveSync = function(dashboard,successFunction,errorFunction)
            {
                //$timeout (function () {

                var dashboardRes = dashboard.getObjectResource();
                dashboardRes.$save({}, //no params
                    function (data) {
                        try{
                            dashboard.setId(data.id);
                            if (!dashboard.version || (data.version && data.version > dashboard.version))
                                dashboard.version = data.version;
                            if (successFunction !== undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure
                        //error handling goes here
                        try{
                            if (errorFunction !== undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );

                //},2000)
            };
            dashboardSrv.remove = function(dashboard,successFunction,errorFunction)
            {
                DashboardData.remove(dashboard);
                ServerSrv.startSavingProcess(dashboardSrv.removeSync, dashboard, successFunction, errorFunction);
            };
            dashboardSrv.removeSync = function(dashboard,successFunction,errorFunction)
            {
                //$timeout (function () {

                var dashboardRes = dashboard.getObjectResource();
                dashboardRes.$remove({id:dashboard.getId()}, //no params
                    function (data) {
                        try{
                            if (successFunction !== undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {
                        //error handling goes here
                        try{
                            if (errorFunction !== undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );

                //},2000)
            };

            dashboardSrv.updateLocally =  function(id,object)
            {
                var dashboard = DashboardData.getById(id);
                if (dashboard!=null){
                    dashboard.setValues(object);
                }
                return dashboard
            };

            dashboardSrv.addLocally =  function(id,object)
            {
                var dashboard = DashboardData.getById(id);
                if (dashboard==null) {
                    var dashboard = new Dashboard(object);
                    dashboard.id = id;
                }
                return dashboard;
            };

            dashboardSrv.removeLocally =  function(id,object)
            {
                var dashboard = DashboardData.getById(id);
                if (dashboard!=null){
                    DashboardData.remove(dashboard);
                }
                return dashboard;
            };

            dashboardSrv.export = function(idDashboard, object, message, beginDayId, endDayId, emailList, successFunction, errorFunction)
            {
                ServerSrv.startSavingProcess(dashboardSrv.exportDashboardSync, idDashboard, object, message, beginDayId, endDayId, emailList, successFunction, errorFunction);
            };

            dashboardSrv.exportDashboardSync = function(idDashboard, object, message, beginDayId, endDayId, emailList, successFunction,errorFunction)
            {
                //$timeout (function () {

                var dashboardRes = new Dashboard_Resource();
                dashboardRes.object = object;
                dashboardRes.message = message;
                dashboardRes.beginDayId = beginDayId;
                dashboardRes.endDayId = endDayId;
                dashboardRes.emailList = emailList;
                dashboardRes.$export({id:idDashboard}, // params
                    function (data) {
                        try{
                            if (successFunction !== undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure
                        //error handling goes here
                        try{
                            if (errorFunction !== undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );

                //},2000)
            };

            return dashboardSrv;
        }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('DashboardData',[
        function ()
        {
            var dashboardData =
            {
                dashboardList : [], // dashboard list for the entire application
                deletedDashboardList : [] // deleted dashboard list for the entire application
            };
            dashboardData.getById =  function(dashboardId)
            {
                for (var i=0;i<this.dashboardList.length;i++)
                    if (this.dashboardList[i].id==dashboardId)
                        return this.dashboardList[i];
                return null;
            }
            dashboardData.getByIndex =  function(dashboardIndex)
            {
                if (dashboardIndex >= 0 && dashboardIndex < this.dashboardList.length)
                {
                    return this.dashboardList[dashboardIndex];
                }
                else
                    return null;
            }
            dashboardData.getIndexOf =  function(dashboard)
            {
                if (dashboard)
                    return this.dashboardList.indexOf(dashboard);
                return -1;
            }
            dashboardData.add = function(dashboard)
            {
                if(!dashboard.isDeleted)
                    this.dashboardList.push(dashboard);
                else
                    this.deletedDashboardList.push(dashboard);
            };
            dashboardData.remove = function(dashboard) //Soft Remove
            {
                if(!dashboard.isDeleted) {
                    var indexDashboardList = this.dashboardList.indexOf(dashboard);
                    if (indexDashboardList != -1) {
                        this.dashboardList.splice(indexDashboardList, 1);
                        this.deletedDashboardList.push(dashboard);
                        dashboard.isDeleted = true;
                    }
                }
            };
            dashboardData.getDashboardList = function()
            {
                return this.dashboardList;
            };
            dashboardData.clear = function()
            {
                this.dashboardList = [];
                this.deletedDashboardList = [];
            };


            return dashboardData;
        }
    ]);


// WEBPACK FOOTER //
// ./js/services/models/Dashboard.js